let cachedCountry: string | null = null;

export function getBrowserCountry(): string {
  if (cachedCountry) return cachedCountry;
  if (typeof window === "undefined") return "US";

  // Gather all preferred browser locales
  const locales =
    Array.isArray(navigator.languages) && navigator.languages.length > 0
      ? navigator.languages
      : [navigator.language || ""];

  // 1. FIRST PASS (Priority: Explicit Region Location):
  // Scan all preferred locales in priority order for a 2-letter country subtag (e.g. 'GB', 'US', 'CA', 'DE')
  for (const locale of locales) {
    if (!locale) continue;

    const parts = locale.split(/[-_]/);
    const regionSubtag = parts.find(
      (part, index) => index > 0 && /^[a-zA-Z]{2}$/.test(part)
    );

    if (regionSubtag) {
      const country = regionSubtag.toUpperCase();
      cachedCountry = country === "GB" ? "UK" : country;
      return cachedCountry;
    }
  }

  // 2. SECOND PASS (Priority: Primary Language Fallback):
  // If no locale provided a region subtag (e.g. user set ["en"]), use the primary language code
  const primaryLang = (locales[0] || "").split(/[-_]/)[0]?.toUpperCase();
  if (primaryLang && primaryLang.length === 2) {
    cachedCountry = primaryLang === "GB" ? "UK" : primaryLang;
    return cachedCountry;
  }

  // 3. FINAL FALLBACK: Default to US
  cachedCountry = "US";
  return cachedCountry;
}
